export const version = '0.807.0'
export const chameleonWebVersion = '10.3.1'
export const chameleonCoreVersion = '7.12.1'
